import { render, staticRenderFns } from "./ChartsBar.vue?vue&type=template&id=d4a63e34"
import script from "./ChartsBar.vue?vue&type=script&lang=js"
export * from "./ChartsBar.vue?vue&type=script&lang=js"
import style0 from "./ChartsBar.vue?vue&type=style&index=0&id=d4a63e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports